import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import { generateButton } from '../helpers/button'

export const ApproveTimesheetForm = (props) => {
  const { handleRemark, handleClickButton, clickApproveOrReject } = props
  const { open/* , remark, */, isApprove } = props

  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => clickApproveOrReject() }
      >
        <HeaderForm toggle={ () => clickApproveOrReject() }>
          <HeadLabel>{`${isApprove === 'approve' ? 'Approve' : 'Reject'} Timesheet`}</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container>
                    <Row style={ { marginTop: 10 } }>
                      <TextLabel >Remarks (Optional)</TextLabel>
                      <TextArea
                        name="remark"
                        onBlur={ (e) => handleRemark(e) }
                      />
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { generateButton(get(props, 'isApprove'), (type) => handleClickButton(type)) }
        </ModalFooter>
      </Modal>
    </div>
  )
}

ApproveTimesheetForm.propTypes = {
  handleClickButton: PropTypes.func,
  open: PropTypes.bool,
  handleRemark: PropTypes.func,
  clickApproveOrReject: PropTypes.func,
  isApprove: PropTypes.string,
}
ApproveTimesheetForm.defaultProps = {
  handleClickButton: () => {},
  open: false,
  handleRemark: () => {},
  clickApproveOrReject: () => {},
  isApprove: 'approve',
}

const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid grey;
`
const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/form/approve-timesheet.js